module.exports = __webpack_public_path__ + "static/media/Katrina Alcorn.f72b03c4.png";